import './AppSelect.scss';

import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { AppDisplay } from '.';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import sortBy from 'lodash/sortBy';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';
import { useDataSecurityApps } from '@hooks';

import React, { useMemo } from 'react';

export const appSelectors = createAsyncSelectors((state) => state.core.dataSecurity.applications.get);

export interface AppSelectProps {
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	includeDetected?: boolean;
	nameAndLabel?: boolean;
	onChange?: (value?: number) => void
	placeholder?: string;
	value?: number;
}

export const AppSelect: React.FC<AppSelectProps> = ({
	getPopupContainer,
	includeDetected,
	nameAndLabel,
	onChange,
	placeholder,
	value
}) => {
	const apps = useDataSecurityApps(false, includeDetected);

	const options = useMemo(() => sortBy(apps.map((app) => ({
		label: <AppDisplay appId={ app.applicationId } />,
		optionLabel: `${app.name}${nameAndLabel && app.label ? ` - ${app.label}` : ''}`,
		value: app.applicationId
	})), (app) => app.label), [ apps, nameAndLabel ]);

	const handleFilter = (input: string, option?: AntdOptionType) =>
		stringContainsSubstringCaseInsensitive(option?.optionLabel as string, input);

	return (
		<Select
			allowClear
			className='app-select'
			classNames={ {
				popup: {
					root: 'app-select-dropdown'
				}
			} }
			filterOption={ handleFilter }
			getPopupContainer={ getPopupContainer ?? getDirectParent }
			onChange={ onChange }
			optionFilterProp='label'
			optionLabelProp='optionLabel'
			options={ options ?? [] }
			placeholder={ placeholder ?? COPY_SPECIFIC.APPLICATION }
			showSearch
			value={ value } />
	);
};
